import styled, { css } from 'styled-components'

import { navDefaultIconColor } from 'assets/styles/variables'

export const NavIconWrapper = styled.div`
  transition: color 0.2s ease;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

// $hidden fades the label to opacity: 0 rather than unmounting it, so it
// dissolves in sync with the row's own width/padding transition (same
// 0.3s cubic-bezier(0.4, 0, 0.2, 1) curve) instead of popping away. Staying
// mounted also means the row keeps an accessible name for screen readers
// even when the sidebar is icon-collapsed.
export const NavLabelRow = styled.span<{ $hidden?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  & > *:last-child {
    margin-left: auto;
  }
`

export const NavText = styled.span<{ $hidden?: boolean }>`
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.25px;
  text-align: center;
  transition:
    color 0.2s ease,
    opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
`

// Shared 32px row geometry for every top-level nav row: the plain link rows
// and the group header button both compose this, so they stay pixel-identical
// by construction rather than by two copies of the same numbers.
export const navRowCss = css<{
  $isActive: boolean
  $isCollapsed: boolean
  $isHighlighted?: boolean
}>`
  box-sizing: border-box;
  padding: 0 6px;
  text-decoration: none !important;
  display: flex;
  height: 32px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  width: ${({ $isCollapsed }) => ($isCollapsed ? '32px' : '100%')};
  border-radius: 6px;
  gap: 12px;
  background: ${({ $isActive, $isHighlighted }) =>
    $isActive ? '#e9e9e9' : $isHighlighted ? '#5072a426' : 'transparent'};
  flex-shrink: 0;
  user-select: none;
  overflow: hidden;
  transition:
    width 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    padding 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    background 0.2s ease;

  ${NavIconWrapper} {
    color: ${({ $isHighlighted }) =>
      $isHighlighted ? '#28364f' : navDefaultIconColor};
  }

  ${NavText} {
    color: ${({ $isHighlighted }) =>
      $isHighlighted ? '#28364f' : navDefaultIconColor};
  }

  &:hover {
    background: #5072a426; // Show background on hover

    ${NavIconWrapper}, ${NavText} {
      color: #28364f; // Dark blue on hover
    }
  }
`
